import { ReportStudioElementMetadata } from '@/modules/ta/reportstudio/models/ReportStudioElementMetadata';
import { ImageDesignOption } from '@/modules/ta/reportstudio/models/element/metadata/ImageDesignOption';

export class ReportStudioImageElementMetadata extends ReportStudioElementMetadata {
  /**
   * @type {string}
   */
  image_url;

  /**
   * @type {string}
   */
  macro_type;

  constructor(model = {}) {
    super(model);

    this.image_url = model.image_url;
    this.macro_type = model.macro_type;
    this.design_options = new ImageDesignOption(model.design_options);
  }
}
